// extracted by mini-css-extract-plugin
export var formContainer = "styles-module__formContainer___pM1Wu";
export var header = "styles-module__header___CCMp4";
export var formSection = "styles-module__formSection___gydJz";